import { put, call, throttle } from "redux-saga/effects";
import {
  makeBooking,
  getWaitTimes,
  cancelBooking,
  updateBooking,
  getBooking,
  makeReservationApi,
  getSessionApi,
} from "./checkInAPI";
import {
  CHECKIN_REQUEST,
  WAITTIME_REQUEST,
  CHECKIN_UPDATE_REQUEST,
  CHECKIN_CANCEL_REQUEST,
  CHECKIN_DETAILS_REQUEST,
  RESERVATION_REQUEST,
  GET_RESERVATION_SESSION_REQUEST,
  RESERVATION_COUNT,
  RESERVATION_TIMESTAMP,
} from "./checkInConstants";
import {
  successBooking,
  failedBooking,
  CheckInActions,
  successWaitTimes,
  failedWaitTimes,
  successCancelBooking,
  failedCancelBooking,
  successEditBooking,
  failedEditbooking,
  successGetBooking,
  failedGetBooking,
  successReservation,
  failedReservation,
  makeReservation,
  sessionDataSuccess,
  sessionDataFaliure,
  forNotable,
} from "./checkInActions";
import {
  CheckInBookingForm,
  WaitTimeRestaurantDetail,
  CancelCheckInDetails,
  CheckInBookingDetails,
  CheckInSuccessResult,
} from "./checkInModels";
import {
  CURRENT_CHECKIN_RESERVATION_ID,
  EXPIRE_TIME,
  CURRENT_RESERVATION_ID,
  RESERVATION_EXPIRE_TIME,
  CURRENT_ACTIVE_RESERVATION_ID,
} from "common/constants";
import { AxiosResponse } from "axios";
import { decryptJson } from "common/utils/react-ec-utils";
import { toast } from "react-toastify";

const getCheckInDetails = (data: CheckInBookingForm) => {
  const CheckInMetaData = {
    deviceId: "",
    channelName: "ONLINE",
    seatTogether: "1",
  };

  let checkInDetails = Object.assign({}, data as any);
  checkInDetails["partySize"] =
    parseInt(checkInDetails["adultSize"]) +
    (parseInt(checkInDetails["kidSize"]) || 0);
  delete checkInDetails["adultSize"];
  delete checkInDetails["restaurantSlug"];
  checkInDetails = Object.assign(
    {},
    checkInDetails,
    CheckInMetaData
  ) as CheckInBookingDetails;
  // console.log('Booking:', checkInDetails);
  return checkInDetails;
};

const getReservationDetails = (data: CheckInBookingForm) => {
  const CheckInMetaData = {
    deviceId: "",
    channelName: "ONLINE",
    seatTogether: "1",
  };

  let checkInDetails = Object.assign({}, data as any);
  // checkInDetails["partySize"] =
  //   parseInt(checkInDetails["adultSize"]) +
  //   (parseInt(checkInDetails["kidSize"]) || 0);
  delete checkInDetails["adultSize"];
  delete checkInDetails["restaurantSlug"];
  checkInDetails = Object.assign(
    {},
    checkInDetails,
    CheckInMetaData
  ) as CheckInBookingDetails;
  // console.log('Booking:', checkInDetails);
  return checkInDetails;
};

function* makeBookingSaga(action: CheckInActions) {
  try {
    const checkInDetails = getCheckInDetails(
      action.payload as CheckInBookingForm
    );

    const response: AxiosResponse = yield call(makeBooking, checkInDetails);

    if (response.status === 200) {
      const data = decryptJson(response.data.encryptedText);

      const responseData = data as CheckInSuccessResult;
      //Store Latest CheckIn ReservationID
      localStorage.setItem(
        EXPIRE_TIME,
        JSON.stringify(new Date().setMinutes(new Date().getMinutes() + 5))
      );
      localStorage.setItem(CURRENT_CHECKIN_RESERVATION_ID, responseData.id);

      const existingId = localStorage.getItem("CURRENT_ACTIVE_RESERVATION_ID");
      const newValue = [existingId, responseData.id].filter(Boolean).join(",");
      localStorage.setItem(CURRENT_ACTIVE_RESERVATION_ID, newValue);
      yield put(successBooking(responseData));
    }
    if (response.status === 400) {
      toast.error(`${response.data.message}`);

      yield put(failedBooking({ message: response.data.message }));
    }
  } catch (err: any) {
    yield put(failedBooking({ message: err?.response.data.message }));
  }
}

function* makeReservationSaga(action: CheckInActions) {
  try {
    const ReservationDetails = getReservationDetails(
      action.payload as CheckInBookingForm
    );

    const response: AxiosResponse = yield call(
      makeReservationApi,
      ReservationDetails
    );

    if (response.status === 200) {
      const data = decryptJson(response.data.encryptedText);
      // console.log({ReservationDetails});
      
      const responseData = data as CheckInSuccessResult;
      localStorage.setItem(
        RESERVATION_EXPIRE_TIME,
        JSON.stringify(new Date().setMinutes(new Date().getMinutes() + 5))
      );
      const [year, month, day] = ReservationDetails.reservationDate.split("-").map(Number);

      // JS months are 0-based, so subtract 1 from month
      const formattedDate = new Date(year, month - 1, day);
      const options: Intl.DateTimeFormatOptions = {
        month: 'short',
        day: 'numeric',
      };
      
const datePart = formattedDate.toLocaleDateString('en-US', options);

const finalFormat = `${datePart}, ${ReservationDetails.reservationSlot}`;
// console.log({finalFormat}); 
      storeTimestamp(finalFormat);

      yield put(successReservation(responseData));
    }

    if (response.status === 400) {
      toast.error(`${response.data.message}`);

      yield put(failedReservation({ message: response.data.message }));
    }
  } catch (err: any) {
    yield put(failedReservation({ message: err?.response.data.message }));
  }
}

function* getWaitTimeSaga(action: CheckInActions) {
  try {
    const response: AxiosResponse = yield call(
      getWaitTimes,
      action.payload as WaitTimeRestaurantDetail
    );
    const decryptdata = decryptJson(response?.data?.encryptedText);
    // console.log(response);
    if (response.status === 200) {
      yield put(successWaitTimes(decryptdata));
    }
  } catch (err) {
    yield put(failedWaitTimes({ message: "WaitTimes couldn't be loaded" }));
  }
}

function* getSessionSaga(action: any) {
  try {
    const response: AxiosResponse = yield call(
      getSessionApi,
      action.payload as string
    );

    // const decryptdata=decryptJson(response?.data?.encryptedText);

    if (response.status === 200) {
      yield put(sessionDataSuccess(response.data));
    }
    else
    {
      if(response.status === 400)
      {
         yield put(forNotable("404 error"));
      }
       yield put(sessionDataFaliure({ message: "Error" }));
    }
  } catch (err) {
    yield put(sessionDataFaliure({ message: "Error" }));
  }
}

function* cancelBookingSaga(action: CheckInActions) {
  try {
    const response: AxiosResponse = yield call(
      cancelBooking,
      action.payload as CancelCheckInDetails
    );
    // console.log(response);
    if (response.status === 200) {
      yield put(successCancelBooking());
    }
  } catch (err) {
    yield put(failedCancelBooking({ message: "Please Try Again" }));
  }
}

function* updateBookingSaga(action: CheckInActions) {
  try {
    const checkInDetails = getCheckInDetails(
      action.payload as CheckInBookingForm
    );
    const response: AxiosResponse = yield call(updateBooking, checkInDetails);
    // console.log(response);
    if (response.status === 200) {
      yield put(successEditBooking(response.data));
    }
  } catch (err) {
    yield put(failedEditbooking({ message: "Please Try Again" }));
  }
}
function storeTimestamp(timestamp: string) {
  const existing = localStorage.getItem(RESERVATION_TIMESTAMP);
  let times: string[] = [];

  if (existing) {
    times = JSON.parse(existing);
  }

  times.push(timestamp);

  localStorage.setItem(RESERVATION_TIMESTAMP, JSON.stringify(times));
}

function* getBookingSaga(action: CheckInActions) {
  try {
    const response: AxiosResponse = yield call(
      getBooking,
      action.payload as string
    );

    if (response.status === 200) {
      const data = decryptJson(response?.data?.encryptedText);

      // console.log("return data",data);
   

      yield put(successGetBooking(data[0]));
    }
  } catch (err) {
    yield put(failedGetBooking({ message: "Please Try Again" }));
  }
}

export default function* checkInSaga() {
  yield throttle(5000, CHECKIN_REQUEST, makeBookingSaga);
  yield throttle(5000, RESERVATION_REQUEST, makeReservationSaga);
  yield throttle(5000, WAITTIME_REQUEST, getWaitTimeSaga);
  yield throttle(5000, CHECKIN_CANCEL_REQUEST, cancelBookingSaga);
  yield throttle(5000, CHECKIN_UPDATE_REQUEST, updateBookingSaga);
  yield throttle(5000, CHECKIN_DETAILS_REQUEST, getBookingSaga);
  yield throttle(5000, GET_RESERVATION_SESSION_REQUEST, getSessionSaga);
}
